<template>
    <div :style="{width: '100%'}">
      <div 
        v-for="(object, index) in data.waterfall" 
        :key="index" 
        :style="{width: '100%', paddingLeft: `${(object.nivel)*12}px`, position: 'relative'}"
        class="splitter-list-container"
      >
        <splitter
          :data="object.splitter"
          :hide="object.hide"
          :nivel="object.nivel - 1"
          :list="data.waterfall"
          :fiber-colors="fiberColors"
          :cables="cables"
          :splitters="splitters"
          @open-menu="openMenu"
        />
      </div>
    </div>
</template>
  
<script>
  import Splitter from './Splitter.vue';
  export default {
    name: "Splitters",
    components: {
      Splitter
    },
    props:{
      data: {
        type: Object
      },
      fiberColors: {
        type: Array
      },
      cables: {
        type: Array
      },
      splitters : {
        type: Array
      }
    },
    methods: {
      openMenu(e, splitter, nivel){
        this.$emit('open-menu', e, splitter, nivel);
      }
    }
  };
</script>


// WEBPACK FOOTER //
// src/components/Home/Forms/_SpecialTabs/Splicing/SplittersInfo/Splitters.vue